module.exports = __webpack_public_path__ + "static/img/shutterstock_464244548.854843d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/landing/shutterstock_464244548.jpg
// module id = 596
// module chunks = 0